export const Arabic: any = {
  dir: "rtl",
  lang: "English",
  font: "cairoFont",
  navFloat: "",
  mAuto: "mr-auto",
  arabicClass: "arabic",
  rowReverse: "row-reverse",
  menuStyle: "arabicMenu",
  menuCloseStyle: "arabicCloseButton",
  textAlign: "text-right",
  textAlignReverse: "text-left",
  FlexAlignItems: "align-items-end",
  noNotifications: "لا يوجد تنبيهات",
  flexDIr: "flex-row-reverse",
  copyRights1: "كل الحقوق محفوظة |",
  terms: "شروط",
  policy: "احكام",
  logout: "خروج",
  headers: {
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    close: "إغلاق",
    sign: "تسجيل ",
    in: "الدخول",
    create: "إنشاء",
    account: "حساب",
    newToShatablee: "جديد لشطبلي؟",
    forgotPassword: "هل نسيت كلمة السر؟",
    registerNow: "سجل الان",
    firstName: "الاسم الأول",
    lastName: "اسم الاخير",
    login: "تسجيل الدخول",
    register: "سجل حسابك",
    invalidOTP: "الرمز غير صحيح",
    confirmPassword: "تأكيد كلمة المرور",
    verify: "تحقق من",
    check: "تحقق",
    otp: "الرمز ",
    resendOTP: "أعد إرسال الرمز؟",
    enterEmailMessage: "أدخل عنوان البريد الإلكتروني المرتبط بحسابك على شطبلي",
    enterPhoneNumberMessage: "أدخل رقم الهاتف المرتبط بحسابك على شطبلي",
    alreadyHaveAnAccount: "هل لديك حساب ؟",
    loginNow: "تسجيل الدخول الآن",
    resetPassword: "إعادة تعيين كلمة المرور",
    redirectingToLogin: "سيتم توجيهك لتسجيل الدخول الآن",
    phoneNumber: "رقم التليفون",
    forgot: "نسيت",
    passwordCapital: "كلمه السر",
    successfullyRegistered: "تم تسجيل الحساب بنجاح",
    enterAValidName: "أدخل اسمًا صالحًا",
    enterAValidNumber: "أدخل رقمًا صالحًا",
    invalidCredentials: "بيانات تسجيل الدخول خاطئة!",
    enterAValidEmail: "أدخل بريد إلكتروني صحيح",
    enterNewPasswordMessage: "أدخل كلمة المرور الجديدة",
    passwordsDoNotMatch: "كلمة المرور غير مطابقة !",
    otpSentMessage: "تم إرسال رمز مكون من 4 أرقام إلى رقم الهاتف المرتبط بحساب شطبلي الخاص بك",
    emailOrNumberAlreadyInUse: "البريد الإلكتروني أو رقم الهاتف قيد الاستخدام بالفعل",
    new: "الجديد",
    displayInformation: "معلومات عرض المستخدم",
    displayName: "الاسم المراد عرضه",
    title: "اللقب",
    secondaryContact: "جهة اتصال ثانوية",
    unit: "الوحدة",
    company: "الشركة",
    dateOfBirth: "تاريخ الميلاد",
    youCantChangeYourEmail: "لا يمكنك تغيير البريد الإلكتروني الخاص بك",
    youCantChangeYourPhone: "لا يمكنك تغيير رقم هاتفك",
    changePassword: "تغيير كلمة المرور",
    cancel: "إلغاء",
    save: "حفظ",
    profileSuccessMessage: "تم تحديث معلومات الملف الشخصي بنجاح!",
    profileErrorMessage: "فشل تحديث معلومات الملف الشخصي ، يرجى المحاولة مرة أخرى!",
    loanApprovalInProgress: "الموافقة على القرض  'قيد التنفيذ'",
    orderPendingApproval: "'الموافقة على الطلب 'قيد التقدم",
    orderRejected: "تم رفض طلبك",
    orderApproved: "تم رفض طلبك",
    loanFormSubmitted: "تم تقديم نموذج القرض",
    yourLoanWithAmount: "قرضك بمبلغ",
    isUnderReview: "قيد المراجعة",
    wasApprovedWithTheAmount: "تمت الموافقة عليه بمبلغ",
    completed: "منجز",
    yourLoanHasBeenRejected: "تم رفض قرضك",
    loanInUnderReview: "القرض قيد المراجعة",
    loanApproved: "تمت الموافقة على القرض",
    loanRejected: "تم رفض القرض"
  },
  invalid: {
    invalidEmail: "البريد الالكتروني غير صحيح",
    requiredEmail: "ادخل البريد الالكتروني",
    requiredUserName: "ادخل الاسم",
    requiredPassword: "ادخل الرقم السري",
    InvalidPassword: "الرقم السري غير صحيح",
    InvalidPercentage: "النسبة غير صحيحة",
    invalidLogin: "تأكد من البيانات",
    invalidRegister: "خطأ في تقديم الطلب ، يرجى المحاولة مرة أخرى",
    loginRedirect: "سيتم إعادة توجيهك بعد قليل",
    requiredField: "من فضلك ادخل البيانات",
    InvalidName: "اسم غير صالح",
    invalidPhoneNumber: 'رقم غير صالح',
    InvalidDescriptionLength: "الطول غير صالح ، يجب أن يكون الوصف أقل من ٢٠٠ حرف",
    InvalidCodeLength: "طول رمز غير صالح ، يجب أن يتكون الرمز من ٥ أحرف",
    InvalidInputArabic: "مسموح بالحروف العربية فقط",
    InvalidInputEnglish: "الإنجليزية",
    InvalidAbbreviationLength: "يجب أن يتكون الاختصار من عشرة أحرف أو أقل"
  },

  showroom: {
    location1: 'NORTH TESEEN',
    location2: 'MARKERS MARK MALL - 2ND FLOOR',
    headerDetails: 'Our hosts are on hand to give a full-tour and walk-around of all of your options – or of course, we can leave you to look around yourselves. We have a no-pressure sales culture here. This means your experience at the showroom will be an enjoyable and informative one.',

  }

}
